import { themes } from '../../theme/theme';
const theme = themes.light;

export const colorVariants = {
  default: {
    primary: {
      backgroundColor: theme.brand_blue[3],
      textColor: theme.white[1],
      borderColor: 'transparent',
    },
    secondary: {
      backgroundColor: theme.brand_blue[7],
      textColor: theme.brand_blue[3],
      borderColor: 'transparent',
    },
    tertiary: {
      backgroundColor: theme.white[1],
      textColor: theme.gray_blue[1],
      borderColor: theme.gray_blue[6],
    },
    outline: {
      backgroundColor: theme.white[1],
      textColor: theme.brand_blue[3],
      borderColor: theme.brand_blue[3],
    },
    text: {
      backgroundColor: theme.white[1],
      textColor: theme.brand_blue[3],
      borderColor: 'transparent',
    },
  },
  danger: {
    primary: {
      backgroundColor: theme.red[3],
      textColor: theme.white[1],
      borderColor: 'transparent',
    },
    secondary: {
      backgroundColor: theme.red[6],
      textColor: theme.red[3],
      borderColor: 'transparent',
    },
    tertiary: {
      backgroundColor: theme.white[1],
      textColor: theme.red[3],
      borderColor: theme.gray_blue[6],
    },
    outline: {
      backgroundColor: theme.white[1],
      textColor: theme.red[3],
      borderColor: theme.red[3],
    },
    text: {
      backgroundColor: theme.white[1],
      textColor: theme.red[3],
      borderColor: 'transparent',
    },
  },
  disabled: {
    primary: {
      backgroundColor: theme.gray_blue[5],
      textColor: theme.gray_blue[4],
      borderColor: 'transparent',
    },
    secondary: {
      backgroundColor: theme.gray_blue[7],
      textColor: theme.gray_blue[4],
      borderColor: 'transparent',
    },
    tertiary: {
      backgroundColor: theme.white[1],
      textColor: theme.gray_blue[4],
      borderColor: theme.gray_blue[6],
    },
    outline: {
      backgroundColor: theme.white[1],
      textColor: theme.gray_blue[4],
      borderColor: theme.gray_blue[5],
    },
    text: {
      backgroundColor: theme.white[1],
      textColor: theme.gray_blue[4],
      borderColor: 'transparent',
    },
  },
};
